class LWModal extends HTMLElement {
    constructor() {
        super();
        this.attachShadow({ mode: 'open' });
    }

    connectedCallback() {
        this.render();
        // Sluiten met Escape
        window.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') this.close();
        });
    }

    open(content) {
        const slot = this.shadowRoot.querySelector('#modal-content');
        slot.innerHTML = content;
        this.setAttribute('active', '');
        document.body.style.overflow = 'hidden'; // Geen scroll op achtergrond
    }

    close() {
        this.removeAttribute('active');
        document.body.style.overflow = 'auto';
    }

    render() {
        this.shadowRoot.innerHTML = /* html */ `
        <style>
            :host {
                display: none;
                position: fixed;
                top: 0; left: 0;
                width: 100vw; height: 100vh;
                background: rgba(0, 0, 0, 0.85);
                z-index: 9999;
                justify-content: center;
                align-items: center;
            }
            :host([active]) { display: flex; }
            
            .close-btn {
                position: absolute;
                top: 20px; right: 30px;
                color: white; font-size: 40px;
                cursor: pointer; line-height: 1;
            }
            #modal-content {
                max-width: 90%; max-height: 80%;
                display: flex; justify-content: center;
            }
            #modal-content img {
                max-width: 100%; max-height: 80vh;
                object-fit: contain;
                box-shadow: 0 0 30px rgba(0,0,0,0.5);
            }
        </style>
        <div class="close-btn">&times;</div>
        <div id="modal-content"></div>
        `;

        this.shadowRoot.querySelector('.close-btn').onclick = () => this.close();
        this.onclick = (e) => { if(e.target === this) this.close(); };
    }
}
customElements.define('lw-modal', LWModal);